export * from './pipes/shared-pipes.module';
export * from './components';
export * from './components/shared.module';
export * from './modules';
export * from './guard/auth.guard';
export * from './guard/can-deactivate.guard';



// WEBPACK FOOTER //
// /var/www/vhosts/vinologiwijnen.nl/httpdocs/crm/resources/assets/src/app/shared/index.ts